export const SEGTYPE_CLICK = 'CLICK'
export const SEGTYPE_HOVER = 'HOVER'
export const SEGTYPE_BOX = 'BOX'
export const SEGTYPE_EVERYTHING = 'EVERYTHING'
export const CLICKTYPE_ADD = 1
export const CLICKTYPE_REMOVE = 0
export const CLICKTYPE_BOX = 2
export const CLICKTYPE_NONE = -1
export const COLOR_ADD = 'rgb(64,224,208)'
export const COLOR_REMOVE = 'rgb(255,192,203)'
